/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_RentInputs */

const en_gc_home_rent = /** @type {(inputs: Gc_Home_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent`)
};

const zh_gc_home_rent = /** @type {(inputs: Gc_Home_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`房租`)
};

/**
* | output |
* | --- |
* | "Rent" |
*
* @param {Gc_Home_RentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_rent = /** @type {((inputs?: Gc_Home_RentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_RentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_rent(inputs)
	return zh_gc_home_rent(inputs)
});
export { gc_home_rent as "gc.home.rent" }